'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = typingMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function typingMiddleware() {
    return function middleware(client, rawEvents, parsedEvents) {
        addFunctionsToClient(client);
        rawEvents.use(theMiddleware);
    };

    function theMiddleware(command, message, rawLine, client, next) {
        if (!(command === 'TAGMSG' && message.tags['+draft/typing']) && !(command === 'PRIVMSG' && message.nick)) {
            next();
            return;
        }

        var target = message.params[0].toLowerCase() === client.user.nick.toLowerCase() ? message.nick : message.params[0];

        var status = message.tags['+draft/typing'] || 'done';

        client.emit('typing', {
            target: target,
            nick: message.nick,
            ident: message.ident,
            hostname: message.hostname,
            status: status
        });

        next();
    }
}

function addFunctionsToClient(client) {
    var typing = client.typing = {};
    var activeTyping = (0, _create2.default)(null);

    function isEnabled() {
        return client.network.cap.isEnabled('message-tags');
    }

    typing.start = function start(target) {
        if (!isEnabled()) {
            return;
        }

        var lastSentStatus = activeTyping[target.toLowerCase()];
        if (lastSentStatus && lastSentStatus > Date.now() - 3000) {
            return;
        }

        activeTyping[target.toLowerCase()] = Date.now();

        var message = new client.Message('TAGMSG', target);
        message.tags['+draft/typing'] = 'active';
        client.raw(message);
    };

    typing.pause = function pause(target) {
        if (!isEnabled()) {
            return;
        }

        var message = new client.Message('TAGMSG', target);
        message.tags['+draft/typing'] = 'paused';
        client.raw(message);
    };

    typing.stop = function stop(target) {
        if (!isEnabled()) {
            return;
        }

        var message = new client.Message('TAGMSG', target);
        message.tags['+draft/typing'] = 'done';
        client.raw(message);

        delete activeTyping[target.toLowerCase()];
    };
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["TypingMiddleware"]
window._kiwi_exports.libs.TypingMiddleware = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/TypingMiddleware.js
// module id = wmYr
// module chunks = 1